import "./src/styles/font.css";
import "./src/styles/global.css";

import { wrapRootElement as wrap } from "./wrapRootElement";

export const wrapRootElement = wrap;
